import { Chat } from '@/components/chat/chat';
import { ProtectedChat } from '@/components/chat/ProtectedChat';
import { NewChat } from '@/components/chat/NewChat';
import { useParams } from 'react-router-dom';

export default function ChatPage({ protectedRoute = false }) {
  const { permitChatId } = useParams();

  const showNewChat = protectedRoute && !permitChatId;

  return (
    // <div className={` ${protectedRoute ? showNewChat ? 'bg-figma-background md:bg-gradient-to-t from-background-secondary to-background-secondary ' : '' : ' bg-figma-background'} text-white flex w-full h-full overflow-hidden`}>
    <div className={`bg-transparent text-white flex w-full h-full overflow-hidden`}>
      <div className="h-full w-full flex flex-col overflow-hidden">
        <div
          className={`flex-1 flex justify-center w-full overflow-hidden ${protectedRoute ? 'overflow-y-auto no-scrollbar' : 'overflow-y-auto no-scrollbar'}`}
        >
          <div className={`w-full h-full flex flex-col ${protectedRoute ? showNewChat ? 'max-w-full' : 'max-w-4xl' : 'max-w-full'}`}>
            {showNewChat ? (
              <NewChat />
            ) : protectedRoute ? (
              <ProtectedChat protectedRoute={protectedRoute} />
            ) : (
              <>
                <Chat protectedRoute={protectedRoute} />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
